/* src/app/master-data/items/list-item/list-item.component.css */
:host {
  display: block;
  margin-bottom: 2rem;
  min-height: 100%;
}
.customer-item-page {
  display: block;
  min-height: 100%;
}
.customer-item-filters {
  display: block;
  background: #d6d8dd;
  padding: 1.5rem;
  border-radius: 0.5rem;
}
:host ::ng-deep .customer-item-table .p-datatable-table {
  table-layout: auto;
}
:host ::ng-deep .customer-item-table .p-datatable-thead > tr > th,
:host ::ng-deep .customer-item-table .p-datatable-tbody > tr > td {
  white-space: nowrap;
  vertical-align: middle;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
:host ::ng-deep .customer-item-table .p-datatable-tbody > tr > td {
  height: 4.75rem;
}
:host ::ng-deep .customer-item-table .p-datatable-wrapper {
  overflow-x: auto;
}
/*# sourceMappingURL=list-item.component-L6YGRPHK.css.map */
